import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CalendarsPartnerState } from './calendars-partner.reducer';

export const selectCalendarsPartnerState = createFeatureSelector<CalendarsPartnerState>('calendarsPartner');

export const selectCalendarsPartnerByKey = (key: string) =>
  createSelector(selectCalendarsPartnerState, (state) => (state.cache || {})[key] ?? null);

// Returns a mutable clone to avoid mutating NgRx-frozen state
export const selectCalendarsPartnerClonedByKey = (key: string) =>
  createSelector(selectCalendarsPartnerByKey(key), (cached: any) => {
    if (cached == null) {
      return cached;
    }

    if (Array.isArray(cached)) {
      return [...cached];
    }

    const partners = Array.isArray(cached.partners)
      ? cached.partners.map((p: any) => ({
          ...p,
          address: p?.address ? { ...p.address } : p?.address,
          bigOrder: p?.bigOrder ? { ...p.bigOrder } : p?.bigOrder,
          pump: p?.pump ? { ...p.pump } : p?.pump,
          dc: Array.isArray(p?.dc) ? p.dc.map((dc: any) => ({ ...dc })) : p?.dc,
        }))
      : cached.partners;

    return { ...cached, partners };
  });

export const selectCalendarsPartnerLoadingByKey = (key: string) =>
  createSelector(selectCalendarsPartnerState, (state) => (state.loading || {})[key] ?? false);

export const selectCalendarsPartnerHasDataByKey = (key: string) =>
  createSelector(selectCalendarsPartnerState, (state) => !!(state.cache || {})[key]);
